import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import Layout, { HomePage } from './App';
import reportWebVitals from './reportWebVitals';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { AdminProvider } from './contexts/AdminContext';
import AdminProtectedRoute from './components/AdminProtectedRoute';
import { MemberProvider } from './contexts/MemberContext';
import { AuthProvider } from './contexts/AuthContext';
import MemberProtectedRoute from './components/MemberProtectedRoute';
import ErrorBoundary from './components/ErrorBoundary';
// Pages
import AboutMe from './pages/AboutMe';
import Login from './pages/Login';
import Signup from './pages/Signup';
import Dashboard from './pages/Dashboard';
import Services from './pages/Services';
import Shop from './pages/Shop';
import Contact from './pages/Contact';
import MyGoals from './pages/MyGoals';
import MyProgress from './pages/MyProgress';
import WorkoutLibraryNew from './pages/WorkoutLibraryNew';
import WorkoutTrackerV2 from './pages/WorkoutTrackerV2';
import MemberRecipes from './pages/MemberRecipes';
import ResourceHub from './pages/ResourceHub';
import ResourceDetail from './pages/ResourceDetail';
import CommunityForum from './pages/CommunityForum';
import MemberProfile from './pages/MemberProfile';
import MyAlera from './pages/MyAlera';
import PlatformUpdates from './pages/PlatformUpdates';
import CheckInJournal from './pages/CheckInJournal';
import CycleTracker from './pages/CycleTracker';
import PrivacyPolicy from './pages/PrivacyPolicy';
import TermsConditions from './pages/TermsConditions';
import RefundCancellation from './pages/RefundCancellation';
import HealthFitnessDisclaimer from './pages/HealthFitnessDisclaimer';
import SubscriptionSuccess from './pages/SubscriptionSuccess';
import ResetPassword from './pages/ResetPassword';
import NotFound from './pages/NotFound';
// Admin Pages
import AdminDashboard from './pages/AdminDashboard';
import AdminLogin from './pages/AdminLogin';
import AdminStats from './pages/AdminStats';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <ErrorBoundary>
      <AuthProvider>
        <AdminProvider>
          <MemberProvider>
            <Router>
          <Routes>
            <Route path="/" element={<Layout />}>
              <Route index element={<HomePage />} />
              <Route path="about" element={<AboutMe />} />
              <Route path="services" element={<Services />} />
              <Route path="shop" element={<Shop />} />
              <Route path="contact" element={<Contact />} />
              <Route path="login" element={<Login />} />
              <Route path="signup" element={<Signup />} />
              <Route path="reset-password" element={<ResetPassword />} />
              <Route path="subscription-success" element={<SubscriptionSuccess />} />
              <Route path="dashboard" element={
                <MemberProtectedRoute>
                  <Dashboard />
                </MemberProtectedRoute>
              } />
              <Route path="my-goals" element={
                <MemberProtectedRoute>
                  <MyGoals />
                </MemberProtectedRoute>
              } />
              <Route path="my-progress" element={
                <MemberProtectedRoute>
                  <MyProgress />
                </MemberProtectedRoute>
              } />
              <Route path="workouts" element={
                <MemberProtectedRoute>
                  <WorkoutLibraryNew />
                </MemberProtectedRoute>
              } />
              <Route path="workouts-v2" element={
                <MemberProtectedRoute>
                  <WorkoutTrackerV2 />
                </MemberProtectedRoute>
              } />
              <Route path="recipes" element={
                <MemberProtectedRoute>
                  <MemberRecipes />
                </MemberProtectedRoute>
              } />
              <Route path="resources" element={
                <MemberProtectedRoute>
                  <ResourceHub />
                </MemberProtectedRoute>
              } />
              <Route path="resources/:id" element={
                <MemberProtectedRoute>
                  <ResourceDetail />
                </MemberProtectedRoute>
              } />
              <Route path="forum" element={
                <MemberProtectedRoute>
                  <CommunityForum />
                </MemberProtectedRoute>
              } />
              <Route path="profile" element={
                <MemberProtectedRoute>
                  <MemberProfile />
                </MemberProtectedRoute>
              } />
              <Route path="my-alera" element={
                <MemberProtectedRoute>
                  <MyAlera />
                </MemberProtectedRoute>
              } />
              <Route path="journal" element={
                <MemberProtectedRoute>
                  <CheckInJournal />
                </MemberProtectedRoute>
              } />
              <Route path="cycle-tracker" element={
                <MemberProtectedRoute>
                  <CycleTracker />
                </MemberProtectedRoute>
              } />
              <Route path="updates" element={<PlatformUpdates />} />
              <Route path="privacy-policy" element={<PrivacyPolicy />} />
              <Route path="terms-conditions" element={<TermsConditions />} />
              <Route path="refund-cancellation" element={<RefundCancellation />} />
              <Route path="health-disclaimer" element={<HealthFitnessDisclaimer />} />
              {/* Admin Routes */}
              <Route path="admin-login" element={<AdminLogin />} />
              <Route path="admin-stats" element={<AdminStats />} />
              <Route path="admin/dashboard" element={
                <AdminProtectedRoute>
                  <AdminDashboard />
                </AdminProtectedRoute>
              } />
              <Route path="*" element={<NotFound />} />
            </Route>
          </Routes>
          </Router>
        </MemberProvider>
      </AdminProvider>
    </AuthProvider>
    </ErrorBoundary>
  </React.StrictMode>
);

// Register Firebase messaging service worker for push notifications
if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/firebase-messaging-sw.js')
      .then((reg) => console.log('FCM SW registered:', reg.scope))
      .catch((err) => console.log('FCM SW registration failed:', err));
  });
}

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
